import { useState, useEffect } from 'react';
import { Input } from './input';
import { Calendar } from 'lucide-react';

/**
 * DateInput component that displays dates in Australian format (DD/MM/YYYY)
 * Stores value as YYYY-MM-DD internally
 */
export function DateInput({ value, onChange, placeholder = "DD/MM/YYYY", className, ...props }) {
  const [displayValue, setDisplayValue] = useState('');

  useEffect(() => {
    if (value) {
      // Convert YYYY-MM-DD to DD/MM/YYYY for display
      const parts = value.split('-');
      if (parts.length === 3) {
        setDisplayValue(`${parts[2]}/${parts[1]}/${parts[0]}`);
      }
    } else {
      setDisplayValue('');
    }
  }, [value]);

  const handleChange = (e) => {
    let input = e.target.value.replace(/[^\d]/g, ''); // Remove non-digits

    // Auto-format as user types
    if (input.length >= 2) {
      input = input.slice(0, 2) + '/' + input.slice(2);
    }
    if (input.length >= 5) {
      input = input.slice(0, 5) + '/' + input.slice(5);
    }
    if (input.length > 10) {
      input = input.slice(0, 10);
    }

    setDisplayValue(input);

    // Parse DD/MM/YYYY and convert to YYYY-MM-DD
    const match = input.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (match) {
      const [, day, month, year] = match;
      const date = `${year}-${month}-${day}`;

      // Validate date
      const dateObj = new Date(date);
      if (!isNaN(dateObj.getTime()) &&
          dateObj.getDate() === parseInt(day) &&
          dateObj.getMonth() + 1 === parseInt(month) &&
          dateObj.getFullYear() === parseInt(year)) {
        onChange(date);
      }
    } else if (input === '') {
      onChange('');
    }
  };

  const handleFocus = (e) => {
    e.target.select();
  };

  return (
    <div className="relative">
      <Input
        type="text"
        value={displayValue}
        onChange={handleChange}
        onFocus={handleFocus}
        placeholder={placeholder}
        className={className}
        maxLength={10}
        {...props}
      />
      <Calendar className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground/70 pointer-events-none" />
    </div>
  );
}
